// extracted by mini-css-extract-plugin
export default {"link":"Transaction_link__bBRtV","no_hover":"Transaction_no_hover__GA5Bv"};